import t from '@/i18n/current';

export const combineLinkWithParameters = (to: string): string => {
    const params = new URLSearchParams(window.location.search);

    for (const excludeParam of [t.formApp.param.amount, t.formApp.param.period, t.formApp.param.url]) {
        params.delete(excludeParam);
    }

    const [url, urlParams] = to.split('?');

    for (const [key, value] of new URLSearchParams(urlParams)) {
        params.set(key, value);
    }

    return params.size ? `${url}?${params.toString()}` : url;
};
